import { Breadcrumb, Dropdown, Icon, Layout, Menu, Modal, Select, Input, Form,notification } from 'antd'
import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import API from '../services/API'

const { Sider, Header, Content } = Layout

// eslint-disable-next-line no-unused-vars
const { SubMenu } = Menu

const BREADCRUMBNAMEMAP = {
    '/home': 'Home',
    '/users': 'Usuarios',
    '/users/create': 'Crear usuarios',
    '/users/edit': 'Editar usuarios',
    '/users/show': 'Detalles del usuario',
    '/users/schedule': 'Horario del usuario',
    '/checkouts': 'Cajas',
    '/checkouts/create': 'Crear cajas',
    '/checkouts/edit': 'Editar cajas',
    '/checkouts/show': 'Detalles de cajas',
    '/customers': 'Clientes',
    '/customers/create': 'Crear clientes',
    '/customers/edit': 'Editar clientes',
    '/customer_types': 'Tipos de precio',
    '/customer_types/edit': 'Editar tipo de precio',
    '/customer_types/create': 'Crea tipo de precio',
    '/categories': 'Categorías',
    '/categories/create': 'Crear categorías',
    '/categories/edit': 'Editar categorías',
    '/subcategories': 'Tipo de producto',
    '/subcategories/create': 'Crear tipo de producto',
    '/subcategories/edit': 'Editar tipo de producto',
    '/subcategories/show': 'Detalle de tipo de producto',
    '/products': 'Productos',
    '/products/create': 'Crear producto',
    '/products/edit': 'Editar producto',
    '/subsidiaries': 'Sucursales',
    '/subsidiaries/create': 'Crear sucursal',
    '/subsidiaries/edit': 'Editar sucursal',
    '/warehouses': 'Almacenes',
    '/warehouses/create': 'Crear almacen',
    '/warehouses/edit': 'Editar almacen',
    '/brands': 'Marcas',
    '/brands/create': 'Crear marca',
    '/brands/edit': 'Editar marca',
    '/measure_units': 'Unidad de medida',
    '/measure_units/create': 'Crear unidad de medida',
    '/measure_units/edit': 'Editar unidad de medida',
    '/measure_units/show': 'Detalle de unidad de medida',
    '/inventory/entry': 'Ingresar inventario',
    '/inventory/transfer': 'Transferir inventario',
    '/report/inventory': 'Reporte de inventario',
    '/report/sales': 'Reporte de ventas',
    '/report/assistances': 'Reportes de asistencia',
    '/discounts': 'Descuentos',
    '/productTypes': 'Tipos de producto',
    '/token': 'Token',
    '/sat_code': 'Codigo sat',
    '/sat_code/create': 'Crear tipo de codigo sat',
    '/sat_code/edit': 'Editar tipo de codigo sat',
    '/sat_code/show': 'Detalle de tipo de codigo sat',
    '/invoices': 'Facturas',
}

const { Option } = Select

class LayoutContainer extends React.Component {
    // eslint-disable-next-line react/state-in-constructor
    state = {
        // eslint-disable-next-line react/no-unused-state
        loading: true,
        collapsed: false,
        visible: false,
        visibleChangePassword: false,
        // eslint-disable-next-line react/no-unused-state
        visibleSubsidiary: true,
        subsidiary: {
            id: '',
            name: '',
        },
        current_password: '',
        password: '',
        password_confirmation: '',
    }
    constructor(props) {
        super()
        this.user = props.user
    }

    componentDidMount() {
        this.setDefaultSubsidiary()
    }

    setDefaultSubsidiary = () => {
        let currentSubsidiary = JSON.parse(localStorage.getItem('sucursal'))

        if (!currentSubsidiary) {
            currentSubsidiary = {
                id: this.user.subsidiaries[0].id,
                name: this.user.subsidiaries[0].name,
            }

            localStorage.setItem('sucursal', JSON.stringify(currentSubsidiary))
        }

        this.setState({
            subsidiary: currentSubsidiary,
        })
    }

    toggle = () => {
        this.setState({
            // eslint-disable-next-line react/no-access-state-in-setstate
            collapsed: !this.state.collapsed,
        })
    }

    // eslint-disable-next-line no-unused-vars
    onCollapse = (collapsed, type) => {
        this.setState({ collapsed })
    }

    renderBreadcumb = () => {
        const { location } = this.props
        const pathSnippets = location.pathname.split('/').filter(i => i)
        const extraBreadcrumbItems = pathSnippets.map((_, index) => {
            const url = `/${pathSnippets.slice(0, index + 1).join('/')}`
            if (!BREADCRUMBNAMEMAP[url]) return false
            return (
                <Breadcrumb.Item key={url}>
                    <Link to={url}>{BREADCRUMBNAMEMAP[url]}</Link>
                </Breadcrumb.Item>
            )
        })

        return (
            <section>
                <Breadcrumb style={{ margin: '10px 0' }}>
                    <Breadcrumb.Item key="/">
                        <Link to="/">
                            <Icon type="home" style={{ margin: '0px 5px' }} />
                            Inicio
                        </Link>
                    </Breadcrumb.Item>
                    {extraBreadcrumbItems}
                </Breadcrumb>
            </section>
        )
    }

    changePassword = () => {
        this.setState({
            visibleChangePassword: true,
        })
    }

    logout = () => {
        localStorage.clear()
        const form = window.document.getElementById('logout-form')
        if (form) {
            form.submit()
        }
    }

    handleOk = e => {
        e.preventDefault()
        this.setState({
            visible: false,
        })
        localStorage.setItem('sucursal', JSON.stringify(this.state.subsidiary))
        window.EventEmitter.emitEvent('subsidiaryChange')
    }

    onSubsidiarySelect = (key, { props }) => {
        this.setState({
            subsidiary: {
                id: key,
                name: props.children,
                label: props.children,
            },
        })
    }
    handleChangePass = (name,value) => {
        this.setState({
                ...this.state,
				[name]: value,
		})
    }

    renderSubsidiaryButton = () => {
        if (!this.user.subsidiaries || this.user.subsidiaries.length === 1) {
            return null
        }

        return (
            <Menu.Item>
                <button
                    type="button"
                    // onClick={this.changeSubsidiary}
                    onClick={() => {
                        this.setState({
                            visible: true,
                        })
                    }}
                    style={{
                        border: 'none',
                        background: 'transparent',
                        width: '100%',
                    }}
                >
                    Cambiar Sucursal
                </button>
            </Menu.Item>
        )
    }

    handleChangePassword = e => {
        e.preventDefault();
        const newData = {
            password: this.state.password,
            current_password: this.state.current_password,
            password_confirmation: this.state.password_confirmation,
          };
        API.patch(`/api/users/${this.user.id}/change-password`, newData)
        .then((response) => {
            if(response.status === 200){
                    this.setState({
                        visibleChangePassword: false,
                        loading: false,
                        current_password: '',
                        password: '',
                        password_confirmation: ''
                    });
                notification.success({
                        message: 'Contraseña restablecida con éxito!.',
                })
           }/*else{
                notification.error({
                    message: response.data.message,
                })
           }*/
        }).catch((error) => {
            this.setState({
                loading: false,
            })
            notification.error({
                message: error.message,
            })
        })

    }
    render() {
        const menu = (
            <Menu>
                {this.renderSubsidiaryButton()}
                <Menu.Item>
                    <button
                        type="button"
                        onClick={this.changePassword}
                        style={{
                            border: 'none',
                            background: 'transparent',
                            width: '100%',
                        }}
                    >
                        Cambiar contraseña
                    </button>
                </Menu.Item>
                <Menu.Item>
                    <button
                        type="button"
                        onClick={this.logout}
                        style={{
                            border: 'none',
                            width: '100%',
                            background: 'transparent',
                        }}
                    >
                        Cerrar sesión
                    </button>
                </Menu.Item>
            </Menu>
        )
        return (
            <Layout style={{ minHeight: '100vh' }}>
                <Sider collapsible collapsed={this.state.collapsed} onCollapse={this.onCollapse} trigger={null}>
                    <div style={{ padding: 16, backgroundColor: 'white' }}>
                        <img width="100%" src="/logo.png" alt="Not Found." />
                    </div>
                    <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline">
                        {/*   <Menu.Item key="1">
                            <Link to="/home">
                                <Icon type="home" />
                                <span>Home</span>
                            </Link>
                        </Menu.Item>
                            */}
                        <Menu.Item key="users">
                            <Link to="/users">
                                <Icon type="user" />
                                <span>Usuarios</span>
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="customers">
                            <Link to="/customers">
                                <Icon type="usergroup-add" />
                                <span>Clientes</span>
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="customer_types">
                            <Link to="/customer_types">
                                <Icon type="usergroup-add" />
                                <span>Tipos de precios</span>
                            </Link>
                        </Menu.Item>

                        <Menu.Item key="categories">
                            <Link to="/categories">
                                <Icon type="gold" />
                                <span>Categorías</span>
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="subcategories">
                            <Link to="/subcategories">
                                <Icon type="gold" />
                                <span>Tipo de producto</span>
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="products">
                            <Link to="/products">
                                <Icon type="gold" />
                                <span>Productos</span>
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="subsidiaries">
                            <Link to="/subsidiaries">
                                <Icon type="shop" />
                                <span>Sucursales</span>
                            </Link>
                        </Menu.Item>
                        {/*     <Menu.Item key="7">
                            <Link to="/warehouses">
                                <Icon type="layout" />
                                <span>Almacenes</span>
                            </Link>
                        </Menu.Item>*/}
                        <Menu.Item key="brands">
                            <Link to="/brands">
                                <Icon type="trademark" />
                                <span>Marcas</span>
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="measure_units">
                            <Link to="/measure_units">
                                <Icon type="tag" />
                                <span>Unidad de medida</span>
                            </Link>
                        </Menu.Item>
                        {this.user.role_id == 1 ? ( //only admin
                            <Menu.Item key="token">
                                <Link to="/token">
                                    <Icon type="lock" />
                                    <span>Token</span>
                                </Link>
                            </Menu.Item>
                        ) : null}

                        <Menu.Item key="sat_code">
                            <Link to="/sat_code">
                                <Icon type="tag" />
                                <span>Codigos sat</span>
                            </Link>
                        </Menu.Item>

                        <Menu.Item key="discounts">
                            <Link to="/discounts">
                                <Icon type="percentage" />
                                <span>Descuentos</span>
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="checkouts">
                            <Link to="/checkouts">
                                <Icon type="dollar" />
                                <span>Cajas</span>
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="invoices">
                            <Link to="/invoices">
                                <Icon type="file-text" />
                                <span>Facturas</span>
                            </Link>
                        </Menu.Item>

                        <SubMenu
                            key="sub1"
                            title={
                                <>
                                    <Icon type="snippets" />
                                    <span>Reportes</span>
                                </>
                            }
                        >
                            <Menu.Item key="report/inventory">
                                <Link to="/report/inventory">
                                    <Icon type="profile" />
                                    <span>Inventario</span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="report/sales">
                                <Link to="/report/sales">
                                    <Icon type="dollar" />
                                    <span>Ventas</span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/report/credit">
                                <Link to="/report/credit">
                                    <Icon type="dollar" />
                                    <span>Credito</span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/report/shifts">
                                <Link to="/report/shifts">
                                    <Icon type="dollar" />
                                    <span>Turnos</span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/report/assistances/general">
                                <Link to="/report/assistances/general">
                                    <Icon type="clock-circle" />
                                    <span>Asistencia general</span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/report/assistances/weekly">
                                <Link to="/report/assistances/weekly">
                                    <Icon type="clock-circle" />
                                    <span>Asistencia semanal</span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/report/cash-withdrawal">
                                <Link to="/report/cash-withdrawal">
                                    <Icon type="dollar" />
                                    <span>Retiro de efectivo</span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/report/cash-withdrawal-reasons">
                                <Link to="/report/cash-withdrawal-reasons">
                                    <Icon type="dollar" />
                                    <span>Motivos de retiro</span>
                                </Link>
                            </Menu.Item>
                        </SubMenu>
                    </Menu>
                </Sider>
                <Layout>
                    <Header style={{ background: 'white', margin: '0px 16px 0px' }}>
                        <Icon
                            className="trigger"
                            type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                            onClick={this.toggle}
                        />
                        <span style={{ margin: 0 }}>{`Sucursal: ${this.state.subsidiary.name}`}</span>
                        <Dropdown overlay={menu}>
                            <div
                                onMouseEnter={() => this.setState({ userLogHover: true })}
                                onMouseLeave={() => this.setState({ userLogHover: false })}
                                style={
                                    this.state.userLogHover
                                        ? {
                                              float: 'right',
                                              background: '#f0f0f0',
                                          }
                                        : { float: 'right', background: '#fff' }
                                }
                            >
                                <div className="ant-dropdown-link" style={{ margin: '0px 15px' }}>
                                    <span style={{ marginRight: '10px' }}>{`Hola, ${this.user.name}`}</span>
                                    <span className="ant-avatar ant-avatar-circle ant-avatar-image">
                                        <img src="a.png" alt="Not found." />
                                    </span>
                                </div>
                            </div>
                        </Dropdown>
                    </Header>
                    <Content style={{ margin: '0 16px 16px' }}>
                        {this.renderBreadcumb()}

                        {React.cloneElement(this.props.children, { user: this.user })}
                    </Content>
                    {/*
					<Footer style={{ textAlign: 'center' }}>
						Ant Design ©2018 Created by Ant UED
					</Footer>
					*/}
                </Layout>
                <Modal
                    title="¿Deseas realizar un cambio de sucursal?"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={() => this.setState({ visible: false })}
                >
                    <Select
                        defaultValue={this.state.subsidiary ? this.state.subsidiary.name : null}
                        style={{ width: '100%' }}
                        placeholder="Seleccione la sucursal"
                        onSelect={this.onSubsidiarySelect}
                    >
                        {this.user.subsidiaries.map(d => (
                            <Option key={d.id}>{d.name}</Option>
                        ))}
                    </Select>
                </Modal>
                <Modal
                    title="Desea realizar un cambio de contraseña?"
                    visible={this.state.visibleChangePassword}
                    onOk={this.handleChangePassword}
                    onCancel={() => this.setState({ visibleChangePassword: false })}
                    onSave={this.handleChangePassword}
                >
                    <Form
                        onSubmit={this.handleChangePassword} className="reset-password-form">
                        <Form.Item>
                            <Input
                                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                type="password"
                                placeholder="Contraseña actual"
                                onChange={e => {
                                    this.handleChangePass('current_password', e.target.value)
                                }}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Input
                                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                type="password"
                                placeholder="Nueva contraseña"
                                onChange={e => {
                                    this.handleChangePass('password', e.target.value)
                                }}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Input
                                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                type="password"
                                placeholder="Confirmar nueva contraseña"
                                onChange={e => {
                                    this.handleChangePass('password_confirmation', e.target.value)
                                }}
                            />
                        </Form.Item>
                    </Form>
                </Modal>
            </Layout>
        )
    }
}

export default withRouter(LayoutContainer)
